import { Card } from '@/components/ui/card';
import { Building2, Users, FolderKanban, Globe } from 'lucide-react';

const STATS = [
  { value: '+5.000', label: 'Empresas Impactadas', icon: Building2 },
  { value: '+1.000.000', label: 'Profesionales Impactados', icon: Users },
  { value: '+10.000', label: 'Proyectos Acompañados', icon: FolderKanban },
  { value: '+17', label: 'Países Alcanzados', icon: Globe },
];

export function ImpactStats() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {STATS.map((stat, i) => (
        <Card
          key={i}
          className="text-center p-5 border-border/50 hover:shadow-lg transition-all bg-gradient-to-br from-card to-card/50"
        >
          <stat.icon className="h-7 w-7 text-primary mx-auto mb-2" />
          <div className="text-2xl md:text-4xl font-bold text-primary mb-1 break-words">
            {stat.value}
          </div>
          <div className="text-sm text-muted-foreground">{stat.label}</div>
        </Card>
      ))}
    </div>
  );
}
